module.exports = __webpack_public_path__ + "success/success-9dfeeb0f734f7407266f915858060ce0.gif";